﻿export const isTruthy = value => !(!value);